import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../http";
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from "../utils";

interface requestDeleteAreaParams {
    propId: string,
    areaId: string,
}

export function useDeleteArea() {
    const queryClient = useQueryClient();
    const forBinding = useForBindingId();
    const mutate = useMutation({
        mutationFn: async ({ propId, areaId }: requestDeleteAreaParams) => {
            try {
                return (await api.delete(`/user/prop/${propId}/area/delete/${areaId}`, {
                    params: { forBinding },
                })).data;
            } catch (error) {
                throw toApiError(error, 'Erro ao deletar área');
            }
        },
        onSuccess: (_, variables) => {
            queryClient.invalidateQueries({ queryKey: ['areas'] });
            queryClient.invalidateQueries({ queryKey: ['propertyId', variables.propId] });
        },
        onError: (error) => console.error('Erro ao deletar área:', getApiErrorMessage(error, 'Erro ao deletar área'))
    })

    return mutate
}
